import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bloc-eco-responsable',
  templateUrl: './bloc-eco-responsable.component.html',
  styleUrls: ['./bloc-eco-responsable.component.scss']
})
export class BlocEcoResponsableComponent implements OnInit {

  constructor() { }

  isMobile;
  ngOnInit(): void {
    if(window.outerWidth < 600){
      this.isMobile=true;
    }else{
      this.isMobile = false;
    }
    };
  }
